import { render, staticRenderFns } from "./statistics-modal.vue?vue&type=template&id=05658fa8&scoped=true"
import script from "./statistics-modal.vue?vue&type=script&lang=ts"
export * from "./statistics-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05658fa8",
  null
  
)

export default component.exports